






















import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { CustomersApi, LocationsApi } from "../../../apis";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { DataOptions, DataTableHeader } from "vuetify";

@Component({
  components: { ValidationObserver, ValidationProvider },
})
export default class AppliedLocationsDialog extends Vue {
  @Prop({ default: false }) value: Boolean;
  @Prop({ default: [] }) appliedLocations: Array<any>;
  get show() {
    return this.value;
  }

  get headers(): DataTableHeader[] {
    return [
      {
        text: this.$t("text.customer").toString(),
        value: "customer",
      },
      {
        text: this.$t("text.location").toString(),
        value: "location",
      },
    ];
  }

  set show(value) {
    this.$emit("input", value);
  }

  mounted() {
  }

}
